'use client';

import { createContext, useContext, ReactNode } from 'react';
import { DEFAULT_LANG, Lang, localePath } from './config';
import { getData } from '@/data/data';

const LangContext = createContext<Lang>(DEFAULT_LANG);

export function LangProvider({ lang, children }: { lang: Lang; children: ReactNode }) {
  return <LangContext.Provider value={lang}>{children}</LangContext.Provider>;
}

export function useLang(): Lang {
  return useContext(LangContext);
}

/** Pfad-Helper: hängt bei EN das /en-Präfix an. */
export function useLocalePath() {
  const lang = useLang();
  return (path: string) => localePath(lang, path);
}

/** Sprachabhängiger Datenzugriff für Client-Komponenten. */
export function useData() {
  return getData(useLang());
}
